//#region src/starters/AiAssistantAudience.ts
var e = /* @__PURE__ */ function(e) {
	return e.Guest = "guest", e.Host = "host", e.Admin = "admin", e;
}({});
//#endregion
export { e as AiAssistantAudience };
